export const SET_MESSAGE = "SET_MESSAGE";   
export const REMOVE_MESSAGE = "REMOVE_MESSAGE";   
